/**
 * ArchiveDealBanner — confirms an archive/unarchive action inline.
 *
 * Chat V1.2 (HANDOFF_CHAT_V1_2_GENERATIVE_TOOLS).
 */
import { Archive } from 'react-feather';

import type { ToolResultProps } from '../lib/component-registry';

interface ArchiveDealResult {
  deal_id?: number;
  deal_name?: string;
  is_archived?: boolean;
  action?: 'archived' | 'unarchived';
  is_error?: boolean;
}

export function ArchiveDealBanner({ result }: ToolResultProps) {
  const r = (result ?? {}) as ArchiveDealResult;

  if (r.is_error) {
    return (
      <div className="mt-2 border border-error/40 bg-error/5 px-3 py-2 text-body-sm text-txt-secondary">
        Could not update deal archive status.
      </div>
    );
  }

  return (
    <div className="mt-2 flex items-center gap-2 border border-border bg-surface-card px-3 py-2 text-body-sm">
      <Archive size={14} className="shrink-0 text-txt-secondary" />
      <p className="text-txt-primary">
        <span className="font-semibold">{r.deal_name ?? `Deal #${r.deal_id}`}</span>
        {' '}
        {r.action === 'archived' ? 'archived' : 'restored'}.
      </p>
    </div>
  );
}
